import { createSlice } from "@reduxjs/toolkit";
import { IFilter, TaskMenuState } from "./types";

import dayjs from "dayjs";

const today = dayjs();
const monthAgo = dayjs().subtract(1, "month");

export const initDateKeys: IFilter[] = [
  { type: "Start", value: monthAgo.format("YYYY-MM-DD") },
  { type: "Finish", value: today.format("YYYY-MM-DD") },
];
export const defaultDate: IFilter[] = [
  { type: "Start", value: monthAgo.format("YYYY-MM-DD") },
  { type: "Finish", value: today.format("YYYY-MM-DD") },
];

const initialState: TaskMenuState = {
  quantity: [],
  keys: initDateKeys,
  activeIndicator: false,
};

const taskTypesSlice = createSlice({
  name: "taskMenu",
  initialState,
  reducers: {
    setQuantity: (state, { payload }) => {
      if (!state.quantity.some((i) => i.mode === payload.mode)) {
        state.quantity.push(payload);
      } else {
        state.quantity = state.quantity.map((i) =>
          i.mode === payload.mode ? payload : i,
        );
      }
    },
    clearQuantity: (state) => {
      state.quantity = [];
    },
    setFilter: (state, { payload }) => {
      state.keys = payload;
    },
    setClearFilter: (state) => {
      state.keys = initDateKeys;
      state.activeIndicator = false;
    },
    setActiveIndicator: (state, { payload }) => {
      state.activeIndicator = payload;
    },
  },
});

export const {
  setQuantity,
  clearQuantity,
  setFilter,
  setClearFilter,
  setActiveIndicator,
} = taskTypesSlice.actions;
export default taskTypesSlice.reducer;
